<template>
  <div>
    <button class="btn btn-sm btn-primary" @click="$refs.createMaterial.showMaterialModal()">新建物料</button>
    
<vue-markdown>
1. 订单状态变为已发货的时候会扣除物料
2. 多次发货会重复扣除物料
3. 基于上面的原因，下表的物料存量会不太准确，请定期清点物料存量

</vue-markdown>

    <pager v-bind:items='this.materials || []'></pager>
    <table class='table table-sm table-hover'>
      <thead>
        <th></th>
        <th>物料名</th>
        <th>存量</th>
        <th>扣除方式</th>
        <th>每次扣除</th>
        <th>操作</th>
      </thead>
      <tbody>
        <tr v-for="(material, index) in materials">
          <td>{{index + 1}}</td>
          <td>
            <router-link :to="'/materials/' + material.mid">{{material.material_name}}</router-link>
          </td>
          <td>{{material.amount}} {{material.unit}}</td>
          <td>{{getChargeOnDisplay(material.charge_on)}}</td>
          <td>{{material.charge_amount}} {{material.unit}}</td>
          <td>
          </td>
        </tr>
      </tbody>
    </table>

    <create-material ref='createMaterial' v-on:refresh="loadData"></create-material>
  </div>
</template>

<script>
import Pager from './_partial/Pager'
import MaterialMixin from '@/mixins/material'
import CreateMaterial from '@/components/_material/CreateMaterial'
import LoadDataMixin from '@/mixins/load_data'
import VueMarkdown from 'vue-markdown'

function loadData () {
  this.$http.get('/api/materials' + location.search).then(response => {
    this.materials = response.data.data
  })
  .catch(function (error) {
    console.log(error)
  })
}

export default {
  name: 'materials',
  mixins: [MaterialMixin, LoadDataMixin],
  components: {CreateMaterial, VueMarkdown, Pager},
  data () {
    return {
      materials: []
    }
  },
  methods: {
    loadData
  },
  mounted () {
    this.loadData()
  }
}
</script>